<template>
  <b-modal v-model="visible" size="xl" :title="$t('people_source_photo')" hide-footer>
    <div v-if="face && face.media" class="source-photo">
      <img :src="sourceUrl" alt="" />
      <span class="face-overlay" :style="overlayStyle" />
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, required: true },
    face: { type: Object, default: null },
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    sourceUrl() {
      return this.face.source_url || `/control/people/faces/${this.face.id}/source`
    },
    overlayStyle() {
      return {
        left: `${this.face.x * 100}%`,
        top: `${this.face.y * 100}%`,
        width: `${this.face.width * 100}%`,
        height: `${this.face.height * 100}%`,
      }
    },
  },
}
</script>

<style scoped>
.source-photo {
  position: relative;
  width: fit-content;
  max-width: 100%;
  margin: auto;
}

.source-photo img {
  display: block;
  max-width: 100%;
  max-height: 75vh;
}

.face-overlay {
  position: absolute;
  border: 3px solid #ffcc00;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, .25);
  pointer-events: none;
}
</style>
